import type { PropsWithChildren } from 'react';
import type React from 'react';

import { SupporterVoicesFeedContextBaseProvider } from './context';
import { useSupporterVoicesFeedContextValue } from './useSupporterVoicesFeedContextValue';

export const SupporterVoicesFeedProvider: React.FC<PropsWithChildren> = ({ children }) => {
	const value = useSupporterVoicesFeedContextValue();

	return <SupporterVoicesFeedContextBaseProvider value={value}>{children}</SupporterVoicesFeedContextBaseProvider>;
};
